import { Collection } from 'modules/core/lib/mobx-rest'
import type { SetOptions } from 'modules/core/lib/mobx-rest/types'

import type { IStatus } from 'modules/bookkeepers/store/models/Status'
import Status from 'modules/bookkeepers/store/models/Status'

class Statuses extends Collection<Status> {
  incidenceId: string

  constructor(data: Status[], incidenceId: string) {
    super(data)
    this.incidenceId = incidenceId
  }

  get cacheKey(): string {
    return 'statuses'
  }

  private get dynamicPath() {
    return `/bookkeepers_management/incidences/${this.incidenceId}/incidence_statuses`
  }

  create(attributes: Partial<IStatus>) {
    return super.create(attributes, { path: this.dynamicPath })
  }

  fetch(options: SetOptions = {}) {
    return super.fetch({ ...options, path: this.dynamicPath })
  }

  model() {
    return Status
  }
}

export default Statuses
